import { AccountResolver } from '@frontend/account/events';
import { AttributeResolver } from '@frontend/attribute/events';
import { BudgetResolver } from '@frontend/budget/events';
import { CertificateResolver } from '@frontend/certificate/events';
import { ColliResolver } from '@frontend/colli/events';
import { AsyncComponent } from '@frontend/components/common';
import { CostCenterResolver } from '@frontend/cost-center/events';
import { DeviceResolver } from '@frontend/device/events';
import { DocumentResolver } from '@frontend/document/events';
import { EquipmentResolver } from '@frontend/equipment/events';
import { EquipmentGroupResolver, ProductCategoryResolver, ProductGroupResolver, QuestionnaireResolver, UserGroupResolver } from '@frontend/group/events';
import { IoTResolver } from '@frontend/iot/events';
import { ModuleResolver } from '@frontend/module/events';
import { PlaylistItemResolver, PlaylistResolver } from '@frontend/playlist/events';
import { ProblemResolver } from '@frontend/problem/events';
import { ProductResolver } from '@frontend/product/events';
import { QuestionResolver } from '@frontend/question/events';
import { CustomRoleResolver } from '@frontend/role/events';
import { SlotResolver } from '@frontend/slot/events';
import { SpotResolver } from '@frontend/spot/events';
import { RequirementResolver, StockResolver } from '@frontend/stock/events';
import { TransactionResolver } from '@frontend/transaction/events';
import { UserResolver } from '@frontend/user/events';
import { WorkflowResolver } from '@frontend/workflow/events';

import { useAppDispatch } from '../redux/store';

const Resolver = (props: { children: React.ReactNode }) => {
    const dispatch = useAppDispatch();
    return (
        <AsyncComponent>
            <ColliResolver dispatch={dispatch} />
            <StockResolver dispatch={dispatch} />
            <ProblemResolver dispatch={dispatch} />
            <DeviceResolver dispatch={dispatch} />
            <IoTResolver dispatch={dispatch} />
            <EquipmentResolver dispatch={dispatch} />
            <CertificateResolver dispatch={dispatch} />
            <ProductResolver dispatch={dispatch} />
            <UserResolver dispatch={dispatch} />
            <BudgetResolver dispatch={dispatch} />
            <DocumentResolver dispatch={dispatch} />
            <UserGroupResolver dispatch={dispatch} />
            <ProductGroupResolver dispatch={dispatch} />
            <ProductCategoryResolver dispatch={dispatch} />
            <QuestionnaireResolver dispatch={dispatch} />
            <EquipmentGroupResolver dispatch={dispatch} />
            <AccountResolver dispatch={dispatch} />
            <CostCenterResolver dispatch={dispatch} />
            <SpotResolver dispatch={dispatch} />
            <ModuleResolver dispatch={dispatch} />
            <PlaylistResolver dispatch={dispatch} />
            <PlaylistItemResolver dispatch={dispatch} />
            <SlotResolver dispatch={dispatch} />
            <WorkflowResolver dispatch={dispatch} />
            <QuestionResolver dispatch={dispatch} />
            <AttributeResolver dispatch={dispatch} />
            <TransactionResolver dispatch={dispatch} />
            <RequirementResolver dispatch={dispatch} />
            <CustomRoleResolver dispatch={dispatch} />
            {props.children}
        </AsyncComponent>
    );
};

export default Resolver;
